import { render, staticRenderFns } from "./MzStar3.vue?vue&type=template&id=33b85eb6&"
import script from "./MzStar3.vue?vue&type=script&lang=js&"
export * from "./MzStar3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports